import { Vector2, Vector3, Color } from 'three';
//import { FileReference, NodeReference, PlugReference, Vec2, Vec3, Color} from './primitives';

function initVector3(from) {
  if (!from) return new Vector3();
  if (from.isVector3) return from;
  if (from.hasOwnProperty('x')) return new Vector3(from.x, from.y, from.z);
  if (Array.isArray(from)) return new Vector3(from[0], from[1], from[2]);
  return new Vector3();
};

function initVector2(from) {
  if (!from) return new Vector2();
  if (from.isVector2) return from;
  if (from.hasOwnProperty('x')) return new Vector2(from.x, from.y);
  if (Array.isArray(from)) return new Vector2(from[0], from[1]);
  return new Vector2();
};

function initColor(from) {
  if (!from) return new Color();
  if (Array.isArray(from)) return new Color(from[0], from[1], from[2]);
  if (from.hasOwnProperty('r')) return new Color(from.r, from.g, from.b);
  if (Number.isInteger(from)) return new Color(from);//hex value
  return new Color();
}

const schemaTypes = {
  Boolean: function (schema) {
    const defaultValue = schema.defaultValue || false;

    return {
      defaultValue,

      set: (val) => {
        return val == null ? defaultValue : !!val;
      },
    };
  },

  Label: function (schema) {
    return {
      set: (val) => {
        return typeof val === 'string' ? val : '';
      },
    };
  },

  Number: function (schema) {
    const min = schema.minValue;
    const max = schema.maxValue;
    const defaultValue = schema.defaultValue || 0;

    let clamp;

    if (min !== undefined && max !== undefined) clamp = (v) => Math.min(Math.max(min, v), max);
    else if (min !== undefined) clamp = (v) => Math.max(v, min);
    else if (max !== undefined) clamp = (v) => Math.min(v, max);
    else clamp = (v) => v;

    return {
      defaultValue,

      set: (val) => {
        let num = Number(val);
        if (isNaN(num)) return defaultValue;
        return Math.round(clamp(num) * 10000) / 10000;
      },
    };
  },

  Integer: function (schema) {
    const min = schema.minValue;
    const max = schema.maxValue;
    const defaultValue = schema.defaultValue || 0;

    let clamp;

    if (min !== undefined && max !== undefined) clamp = (v) => Math.min(Math.max(min, v), max);
    else if (min !== undefined) clamp = (v) => Math.max(v, min);
    else if (max !== undefined) clamp = (v) => Math.min(v, max);
    else clamp = (v) => v;

    return {
      defaultValue,

      set: (val) => {
        const num = Number(val);
        if (isNaN(num)) return defaultValue;
        return Math.round(clamp(num));
      },
    };
  },

  Plug: function (schema) {
    if (!schema.plug) throw new Error('plug property expects a `plug` property');

    return {
      isPlugReference: schema.plug,

      set: (id) => {
        if (id && id.id) return id.id;
        return id;
      },
    };
  },

  Options: function (schema) {
    const defaultValue = schema.defaultValue;
    return {
      defaultValue,

      set: (val) => {
        return val == null ? defaultValue : val;
      },
    };
  },

  Image: function (schema) {
    return {
      isFileReference: true,

      set: (id) => {
        if (id && id.id) return id.id;
        return id; // ? FileReference({id}) : null;
      },
    };
  },

  Binary: function (schema) {
    return {
      isFileReference: true,

      set: (id) => {
        if (id && id.id) return id.id;
        return id; // ? FileReference({id}) : null;
      },
    };
  },

  File: function (schema) {
    return {
      isFileReference: true,

      set: (id) => {
        if (id && id.id) return id.id;
        return id; // ? FileReference({id}) : null;
      },
    };
  },

  Object: function (schema) {
    const defaultValue = schema.defaultValue || {};
    return {
      set: (obj) => {
        return obj || defaultValue;
      },

      equals: (val1, val2) => {
        return (JSON.stringify(val1) === JSON.stringify(val2));
      },
    };
  },

  String: function (schema) {
    const defaultValue = schema.defaultValue || '';

    return {
      defaultValue,

      set: (str) => {
        return typeof str === 'string' ? str : defaultValue;
      },
    };
  },

  Node: function (schema) {
    return {
      isNodeReference: true,

      set: (id) => {
        if (id && id.id) return id.id;
        return id; // ? NodeReference({id}) : null;
      },
    };
  },

  NodeList: function (schema) {
    return {
      isReferenceList: true,

      set: (ids) => {
        if (Array.isArray(ids)) {
          return ids.map((id) => id && id.id ? id.id : id);
        }

        return [];
      },

      equals: (val1, val2) => {
        return JSON.stringify(val1) === JSON.stringify(val2);
      },
    };
  },

  Vec2: function (schema) {
    const defaultValue = initVector2(schema.defaultValue);

    return {
      defaultValue,

      set: (val) => {
        return initVector2(val || defaultValue);
      },

      get: (val) => {
        return val.clone();
      },

      equals: (val1, val2) => {
        return val1.equals(val2);
      },
    };
  },

  Color: function (schema) {
    const defaultValue = initColor(schema.defaultValue);

    return {
      defaultValue,

      set: (val) => {
        return initColor(val || defaultValue);
      },

      get: (val) => {
        return val.clone();
      },

      equals: (val1, val2) => {
        return val1.equals(val2);
      },
    };
  },

  Vec3: function (schema) {
    const defaultValue = initVector3(schema.defaultValue);

    return {
      defaultValue,

      set: (val) => {
        return initVector3(val || defaultValue);
      },

      get: (val) => {
        return val.clone();
      },

      equals: (val1, val2) => {
        return val1.equals(val2);
      },
    };
  },
};

export default schemaTypes;



// WEBPACK FOOTER //
// ./src/operators/schemaTypes.js